var _style, _path, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForexPro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 238 179",
    style: {
      enableBackground: "new 0 0 238 179"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Rectangle_00000034799540305166183090000006660773517574340799_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-24_00000104685273664284802830000015063772473515516562_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-40_00000031910785542119137510000000423877127603677366_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Rectangle-Copy_00000101095786957219532580000000673060959413486999_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-25_00000086660391076045263000000016376142307343373752_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-41_00000160183734681554697620000014130129580362381246_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Rectangle-Copy_00000044867774046421094550000011406611903181552782_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-29_00000043424853176951308460000009388019719952690831_);}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-42_00000100382178779379156320000017575111343229923459_);}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Rectangle-Copy_00000035523165367835813930000007930772607556557487_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-28_00000012464260885539503790000002592022067334083511_);}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-43_00000029747386213209026030000013395807431896940709_);}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Rectangle-Copy_00000090987474710671337750000012346745952148764337_);}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-31_00000062908218055005072080000013037596788674172044_);}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-32_00000034767914388984686060000015911415818275948418_);}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-33_00000035499657933539660350000012452695554417771199_);}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-34_00000055689506798626657960000010252620618071224767_);}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Rectangle-Copy_00000171692639313605733370000010307397440727701171_);}\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-31_00000116934890579306024600000011143332295659318445_);}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-32_00000021830511471938268120000017126179538541774523_);}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-33_00000165954976967269751850000002890477734374238377_);}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-34_00000173125661567464523960000014238876318374837177_);}\n\t.st22{fill:url(#SVGID_1_);}\n\t.st23{clip-path:url(#SVGID_00000034086468439900682650000002912217403368821433_);}\n\t.st24{fill:url(#SVGID_00000052103617213097778310000013407737181203886500_);}\n\t.st25{fill:url(#SVGID_00000123442256829600089260000014924271737863198642_);}\n\t.st26{clip-path:url(#SVGID_00000115505443437705890990000002543770994077584061_);}\n\t.st27{fill:url(#SVGID_00000154421522120912869730000001352963685538358146_);}\n\t.st28{fill:url(#SVGID_00000047027897536599261170000015917181212251068351_);}\n\t.st29{clip-path:url(#SVGID_00000044165085873779556290000002857193454161919667_);}\n\t.st30{fill:url(#SVGID_00000122697717474805326740000012616743661899845019_);}\n\t.st31{fill:url(#SVGID_00000183218511600351483230000001852217649368076678_);}\n\t.st32{clip-path:url(#SVGID_00000098939017780571493080000000016514430041284011_);}\n\t.st33{fill:url(#SVGID_00000160150425312968356100000014275196487435789209_);}\n\t.st34{fill:url(#SVGID_00000181767427775951251260000013201761142081974659_);}\n\t.st35{clip-path:url(#SVGID_00000102526510506611205060000004582378356498468799_);}\n\t.st36{fill:url(#SVGID_00000119095840675686482180000010850479192926028187_);}\n\t.st37{fill:url(#SVGID_00000041272720751145841690000005103376429277255057_);}\n\t.st38{clip-path:url(#SVGID_00000122691042315719344800000013762170935831583126_);}\n\t.st39{fill:url(#SVGID_00000180357049480642666930000003707200413921162899_);}\n\t.st40{fill:url(#SVGID_00000155863240963261484890000012181128617779679620_);}\n\t.st41{clip-path:url(#SVGID_00000074408574091193989560000013104452531537282205_);}\n\t.st42{fill:url(#SVGID_00000052095049720547762090000015311751173119069338_);}\n\t.st43{fill:url(#SVGID_00000055668444051116471440000013942463853339744414_);}\n\t.st44{fill:url(#SVGID_00000036248715388823600800000013679184748699664289_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_00000088846036826971854410000010764894409321900214_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.2208,
    y1: 119.0157,
    x2: 111.7744,
    y2: 119.0157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Rectangle_00000088846036826971854410000010764894409321900214_)"
    },
    d: " M108.4,73.6h2.1c0.7,0,1.2,0.5,1.2,1.2v88.3c0,0.7-0.5,1.2-1.2,1.2h-2.1c-0.7,0-1.2-0.5-1.2-1.2V74.8 C107.2,74.2,107.8,73.6,108.4,73.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-24_00000171699475480505765780000015227108887811639457_",
    gradientUnits: "userSpaceOnUse",
    x1: -843.2382,
    y1: 1079.1207,
    x2: -843.2382,
    y2: 1079.8492,
    gradientTransform: "matrix(25.8314 0 0 -68.0091 21891.5469 73543.4844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#3D2511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    style: {
      stopColor: "#7C592B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2122,
    style: {
      stopColor: "#B98A39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    style: {
      stopColor: "#E6AF3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5802,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-24_00000171699475480505765780000015227108887811639457_)"
    },
    d: " M103.3,103.9h12.5c1.7,0,3.2,1.4,3.2,3.2v43.2c0,1.7-1.4,3.2-3.2,3.2h-12.5c-1.7,0-3.2-1.4-3.2-3.2V107 C100.1,105.3,101.5,103.9,103.3,103.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-40_00000078758621616252205360000010733100545758775967_",
    gradientUnits: "userSpaceOnUse",
    x1: -843.179,
    y1: 1071.6993,
    x2: -843.3077,
    y2: 1072.4279,
    gradientTransform: "matrix(25.8293 0 0 -43.4539 21889.7266 46704.5586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-40",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-40_00000078758621616252205360000010733100545758775967_)"
    },
    d: " M118.9,117.7V107c0-1.7-1.4-3.2-3.2-3.2h-12.5c-1.7,0-3.2,1.4-3.2,3.2v28.5C101.5,125.7,109.5,119.2,118.9,117.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-Copy_00000054972783525723175240000009769656149396896923_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.5423,
    y1: 94.73,
    x2: 88.0958,
    y2: 94.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Rectangle-Copy_00000054972783525723175240000009769656149396896923_)"
    },
    d: " M84.8,62.4h2.1c0.7,0,1.2,0.5,1.2,1.2v62.2c0,0.7-0.5,1.2-1.2,1.2h-2.1c-0.7,0-1.2-0.5-1.2-1.2V63.6C83.5,62.9,84.1,62.4,84.8,62.4 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-25_00000140003774685060941870000010876707761231479220_",
    gradientUnits: "userSpaceOnUse",
    x1: -842.8934,
    y1: 1075.4493,
    x2: -842.8934,
    y2: 1076.178,
    gradientTransform: "matrix(25.8293 0 0 -53.8283 21857.168 58002.8555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#3D2511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    style: {
      stopColor: "#7C592B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2122,
    style: {
      stopColor: "#B98A39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    style: {
      stopColor: "#E6AF3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5802,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-25_00000140003774685060941870000010876707761231479220_)"
    },
    d: " M79.5,74h12.5c1.7,0,3.2,1.4,3.2,3.2V110c0,1.7-1.4,3.2-3.2,3.2H79.5c-1.7,0-3.2-1.4-3.2-3.2V77.1C76.4,75.4,77.8,74,79.5,74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-41_00000152952478832477956740000011761895659633555126_",
    gradientUnits: "userSpaceOnUse",
    x1: -842.8369,
    y1: 1071.4434,
    x2: -842.9656,
    y2: 1072.1719,
    gradientTransform: "matrix(25.8293 0 0 -43.4543 21857.168 46663.9961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-41_00000152952478832477956740000011761895659633555126_)"
    },
    d: " M95.2,87.9V77.1c0-1.7-1.4-3.2-3.2-3.2H79.5c-1.7,0-3.2,1.4-3.2,3.2v28.5C77.8,95.8,85.8,89.3,95.2,87.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-Copy_00000045610588605194542110000002232004543176204421_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.8815,
    y1: 94.73,
    x2: 159.435,
    y2: 94.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy_1_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Rectangle-Copy_00000045610588605194542110000002232004543176204421_)"
    },
    d: " M156.1,62.4h2.1c0.7,0,1.2,0.5,1.2,1.2v62.2c0,0.7-0.5,1.2-1.2,1.2h-2.1c-0.7,0-1.2-0.5-1.2-1.2V63.6 C154.9,62.9,155.4,62.4,156.1,62.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-29_00000013186882922877899850000006586551097940527001_",
    gradientUnits: "userSpaceOnUse",
    x1: -843.9225,
    y1: 1075.4493,
    x2: -843.9225,
    y2: 1076.178,
    gradientTransform: "matrix(25.8314 0 0 -53.8283 21956.668 58002.8555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#3D2511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    style: {
      stopColor: "#7C592B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2122,
    style: {
      stopColor: "#B98A39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    style: {
      stopColor: "#E6AF3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5802,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-29_00000013186882922877899850000006586551097940527001_)"
    },
    d: " M150.7,74h12.5c1.7,0,3.2,1.4,3.2,3.2V110c0,1.7-1.4,3.2-3.2,3.2h-12.5c-1.7,0-3.2-1.4-3.2-3.2V77.1C147.6,75.4,149,74,150.7,74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-42_00000102531280016940358510000011230019407237349535_",
    gradientUnits: "userSpaceOnUse",
    x1: -843.8633,
    y1: 1071.4434,
    x2: -843.992,
    y2: 1072.1719,
    gradientTransform: "matrix(25.8293 0 0 -43.4543 21954.8457 46663.9961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-42",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-42_00000102531280016940358510000011230019407237349535_)"
    },
    d: " M166.4,87.9V77.1c0-1.7-1.4-3.2-3.2-3.2h-12.5c-1.7,0-3.2,1.4-3.2,3.2v28.5C148.9,95.8,157,89.3,166.4,87.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-Copy_00000145772400074980937770000001754624797766438066_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.2029,
    y1: 119.0157,
    x2: 135.7565,
    y2: 119.0157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy_2_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Rectangle-Copy_00000145772400074980937770000001754624797766438066_)"
    },
    d: " M132.4,73.6h2.1c0.7,0,1.2,0.5,1.2,1.2v88.3c0,0.7-0.5,1.2-1.2,1.2h-2.1c-0.7,0-1.2-0.5-1.2-1.2V74.8 C131.2,74.2,131.7,73.6,132.4,73.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-28_00000080173579522505236380000012960642965205684410_",
    gradientUnits: "userSpaceOnUse",
    x1: -843.5777,
    y1: 1079.1207,
    x2: -843.5777,
    y2: 1079.8492,
    gradientTransform: "matrix(25.8293 0 0 -68.0091 21922.2852 73543.4844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#3D2511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    style: {
      stopColor: "#7C592B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2122,
    style: {
      stopColor: "#B98A39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    style: {
      stopColor: "#E6AF3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5802,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-28_00000080173579522505236380000012960642965205684410_)"
    },
    d: " M127,103.9h12.5c1.7,0,3.2,1.4,3.2,3.2v43.2c0,1.7-1.4,3.2-3.2,3.2H127c-1.7,0-3.2-1.4-3.2-3.2V107 C123.8,105.3,125.2,103.9,127,103.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-43_00000160884738025357286420000016620245839345104785_",
    gradientUnits: "userSpaceOnUse",
    x1: -843.5238,
    y1: 1071.6993,
    x2: -843.6525,
    y2: 1072.4279,
    gradientTransform: "matrix(25.8314 0 0 -43.4539 21924.1074 46704.5586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-43",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-43_00000160884738025357286420000016620245839345104785_)"
    },
    d: " M142.6,117.7V107c0-1.7-1.4-3.2-3.2-3.2H127c-1.7,0-3.2,1.4-3.2,3.2v28.5C125.2,125.7,133.2,119.2,142.6,117.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-Copy_00000029005940975668130620000018140198349099165360_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.8637,
    y1: 78.489,
    x2: 64.4173,
    y2: 78.489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy_3_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Rectangle-Copy_00000029005940975668130620000018140198349099165360_)"
    },
    d: " M61.1,63.3h2.1c0.7,0,1.2,0.5,1.2,1.2v27.9c0,0.7-0.5,1.2-1.2,1.2h-2.1c-0.7,0-1.2-0.5-1.2-1.2V64.5C59.9,63.9,60.4,63.3,61.1,63.3 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-31_00000002352980275860979280000014912474649897060515_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.3493,
    y1: 387.6567,
    x2: 26.1693,
    y2: 387.6567,
    gradientTransform: "matrix(0 -1 1 0 -325.7624 96.0159)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-31_00000002352980275860979280000014912474649897060515_)"
    },
    d: " M52.3,85.8v-13c0-1.6,1.3-2.9,2.9-2.9h13.4c1.8,0.2,2.9,1.3,2.9,2.9v13c0,1.6-1.3,2.9-2.9,2.9H55.2C53.6,88.7,52.3,87.4,52.3,85.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-32_00000000934755056812110010000007431126289911158178_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.0829,
    y1: 53.1735,
    x2: 71.5446,
    y2: 53.1735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-32",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-32_00000000934755056812110010000007431126289911158178_)"
    },
    d: " M55,69.8c-29.5,0-32-31.8,0.4-47.6c2.9-1.4,1.8-3.6-0.5-2.9C2.3,35.2,7.1,87.2,53.8,87.2l17.8-0.2c0,0,0-10.5,0-13.7 c0-3.1-2.3-3.4-2.3-3.4H55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-33_00000022544804392788567210000017395763320542142364_",
    gradientUnits: "userSpaceOnUse",
    x1: -864.3259,
    y1: 1071.8826,
    x2: -864.892,
    y2: 1071.9728,
    gradientTransform: "matrix(74.8295 0 0 -44.0954 64748.7422 47341.293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#3D2511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    style: {
      stopColor: "#7C592B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2122,
    style: {
      stopColor: "#B98A39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    style: {
      stopColor: "#E6AF3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5802,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9551,
    style: {
      stopColor: "#BE982E",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-33",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-33_00000022544804392788567210000017395763320542142364_)"
    },
    d: " M53.7,89h14.9c1.6,0,2.9-1.3,2.9-2.9v-6.6C51.9,81.2,22.2,80.6,23,56.9h-6C16.1,72.8,29.1,89,53.7,89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-34_00000163055116650347680510000005137822142934219663_",
    gradientUnits: "userSpaceOnUse",
    x1: -855.9958,
    y1: 1074.3646,
    x2: -856.2639,
    y2: 1073.9387,
    gradientTransform: "matrix(43.1808 0 0 -50.3443 37004.6562 54121.0586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#3D2511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    style: {
      stopColor: "#7C592B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2122,
    style: {
      stopColor: "#B98A39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    style: {
      stopColor: "#E6AF3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4494,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8979,
    style: {
      stopColor: "#CEAD33",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-34",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-34_00000163055116650347680510000005137822142934219663_)"
    },
    d: " M32.7,56.9c-3.4-10.6,3.6-25.4,22.5-34.7c1.3-0.6,1.8-1.4,1.8-2C41.3,25.8,25.2,37,25.6,56.9H32.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-Copy_00000067197668091030096160000014812156195812643769_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.56,
    y1: 78.489,
    x2: 183.1135,
    y2: 78.489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy_4_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Rectangle-Copy_00000067197668091030096160000014812156195812643769_)"
    },
    d: " M181.9,63.3h-2.1c-0.7,0-1.2,0.5-1.2,1.2v27.9c0,0.7,0.5,1.2,1.2,1.2h2.1c0.7,0,1.2-0.5,1.2-1.2V64.5 C183.1,63.9,182.6,63.3,181.9,63.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-31_00000071520161449448927240000003187011672948714414_",
    gradientUnits: "userSpaceOnUse",
    x1: -196.5646,
    y1: -25.6139,
    x2: -177.7446,
    y2: -25.6139,
    gradientTransform: "matrix(0 1 -1 0 155.3622 266.416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31_1_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-31_00000071520161449448927240000003187011672948714414_)"
    },
    d: " M190.6,85.8v-13c0-1.6-1.3-2.9-2.9-2.9l-13.4,0c-1.6,0-2.9,1.3-2.9,2.9l0,13c0,1.6,1.3,2.9,2.9,2.9h13.4 C189.3,88.7,190.6,87.4,190.6,85.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-32_00000084497509578445255920000011124406409370559673_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.3801,
    y1: 53.2203,
    x2: 225.9171,
    y2: 53.2203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5051,
    style: {
      stopColor: "#BD952E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEAD33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F3519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-32_1_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-32_00000084497509578445255920000011124406409370559673_)"
    },
    d: " M188,69.9c29.5,0,32-31.8-0.4-47.6c-2.9-1.4-1.8-3.6,0.5-2.9c52.6,15.9,47.8,67.9,1.1,67.9l-17.8-0.7l0-13.8c0-0.2,0.1-1.4,0.7-2 c0.8-0.8,2.2-0.9,2.2-0.9L188,69.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-33_00000119112074353023498070000010445418954259539333_",
    gradientUnits: "userSpaceOnUse",
    x1: -887.1714,
    y1: 1071.8826,
    x2: -887.7375,
    y2: 1071.9728,
    gradientTransform: "matrix(-74.8295 0 0 -44.0954 -66215.3828 47341.293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#3D2511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    style: {
      stopColor: "#7C592B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2122,
    style: {
      stopColor: "#B98A39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    style: {
      stopColor: "#E6AF3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5802,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9551,
    style: {
      stopColor: "#BE982E",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-33_1_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-33_00000119112074353023498070000010445418954259539333_)"
    },
    d: " M189.2,89h-14.9c-1.6,0-2.9-1.3-2.9-2.9v-6.6c19.6,1.6,49.3,1.1,48.5-22.7h6C226.7,72.8,213.8,89,189.2,89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-34_00000013878932848536383610000015907866313923355832_",
    gradientUnits: "userSpaceOnUse",
    x1: -895.5856,
    y1: 1074.3646,
    x2: -895.8536,
    y2: 1073.9387,
    gradientTransform: "matrix(-43.1808 0 0 -50.3443 -38471.3008 54121.0586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#3D2511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    style: {
      stopColor: "#7C592B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2122,
    style: {
      stopColor: "#B98A39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    style: {
      stopColor: "#E6AF3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#FEC240"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4494,
    style: {
      stopColor: "#B0762A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#BE982E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#CEAD33",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-34_1_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Fill-34_00000013878932848536383610000015907866313923355832_)"
    },
    d: " M210.1,56.9c3.4-10.6-3.6-25.4-22.5-34.7c-1.3-0.6-1.8-1.4-1.8-2c15.7,5.6,31.8,16.8,31.5,36.7H210.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -132.7128,
    y1: 59.3251,
    x2: -132.7128,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 1.037598e-02 184.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M-133.5,67.5c-0.1,1.7,0.2,3.4,1,4.9c0.9,1.7,1.7,3.4,2.4,5.1c0.4,1.4,0.7,2.9,0.7,4.5 c0.2,3.1-0.8,6.2-2.8,8.6c-2.8,3.3-7.2,4.7-10.8,6.9c-6.6,4.1-7,13.5-2.9,19.4c0.3,0.5,0.7,1,1.1,1.4c1.6,1.7,3.8,2.9,6.1,3.4 c1.1,0.2,1.2,0.2,1.5,0.3c1.1,0.2,2.2,0.3,3.3,0.3h0.1c2,0,3.9-0.3,5.8-0.8c-2.1,0.5-4.4,0.1-6.3-0.9c-2.7-1.5-3.6-5.5-3-8.3 c0.5-2.4,2-4.4,4.1-5.6c2.5-1.4,5.3-1.8,7.9-2.9c6.8-3.2,9.9-11,8.2-18.2c-1.1-4.7-3.6-9.8-7.5-12.7c-1.5-1-3-2.2-4.2-3.6 c-0.8-1-1.4-2.1-1.8-3.2c-0.3-1.1-0.4-2.3-0.3-3.5C-132.5,63.3-133.5,66-133.5,67.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000059286506698921682430000009947748864878701743_",
    d: "M-133.5,67.5c-0.1,1.7,0.2,3.4,1,4.9 c0.9,1.7,1.7,3.4,2.4,5.1c0.4,1.4,0.7,2.9,0.7,4.5c0.2,3.1-0.8,6.2-2.8,8.6c-2.8,3.3-7.2,4.7-10.8,6.9c-6.6,4.1-7,13.5-2.9,19.4 c0.3,0.5,0.7,1,1.1,1.4c1.6,1.7,3.8,2.9,6.1,3.4c1.1,0.2,1.2,0.2,1.5,0.3c1.1,0.2,2.2,0.3,3.3,0.3h0.1c2,0,3.9-0.3,5.8-0.8 c-2.1,0.5-4.4,0.1-6.3-0.9c-2.7-1.5-3.6-5.5-3-8.3c0.5-2.4,2-4.4,4.1-5.6c2.5-1.4,5.3-1.8,7.9-2.9c6.8-3.2,9.9-11,8.2-18.2 c-1.1-4.7-3.6-9.8-7.5-12.7c-1.5-1-3-2.2-4.2-3.6c-0.8-1-1.4-2.1-1.8-3.2c-0.3-1.1-0.4-2.3-0.3-3.5 C-132.5,63.3-133.5,66-133.5,67.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127753410725251919100000002276812450743257223_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059286506698921682430000009947748864878701743_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127753410725251919100000002276812450743257223_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131367133493659314020000006968466852922507184_",
    gradientUnits: "userSpaceOnUse",
    x1: -132.7772,
    y1: 59.3251,
    x2: -132.7772,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 -8.071196e-03 184.1057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000131367133493659314020000006968466852922507184_)"
    },
    points: "-173.6,73.8 -122.1,48.8  -92,110.8 -143.5,135.8  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015328827353577969260000009919745554415003299_",
    gradientUnits: "userSpaceOnUse",
    x1: -145.3997,
    y1: 59.3251,
    x2: -145.3997,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 1.037598e-02 184.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015328827353577969260000009919745554415003299_)"
    },
    d: "M-137.6,77.6c-1.5,4.5-5,7.7-10,7.5 c-3.1-0.1,0.2-4.3,0.4-4.5c-1.9,1.3-3.6,2.9-5.1,4.8c-5.3,6.9-6.3,16.3-2.4,24.1c1,2,2.3,3.9,3.8,5.5c0.8,0.9,1.6,1.6,2.5,2.3 c0.3,0.2,1.7,1.2,2.1,1.5c-1.3-1.1-2.5-2.4-3.4-3.9c-1.8-3.4-2.5-7.3-2-11.1c0.1-1,0.4-2,0.8-3c3.3-7.5,14-7.9,16.5-16.1 c1.2-3.8,0.5-7.9-1.7-11.2c-0.3-0.4-0.6-0.8-0.9-1.1c0,0-0.5-0.4-0.5-0.4C-137.4,73.3-137,75.8-137.6,77.6 M-137.4,72L-137.4,72"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000042715499702440123190000016714576248755122075_",
    d: "M-137.6,77.6c-1.5,4.5-5,7.7-10,7.5 c-3.1-0.1,0.2-4.3,0.4-4.5c-1.9,1.3-3.6,2.9-5.1,4.8c-5.3,6.9-6.3,16.3-2.4,24.1c1,2,2.3,3.9,3.8,5.5c0.8,0.9,1.6,1.6,2.5,2.3 c0.3,0.2,1.7,1.2,2.1,1.5c-1.3-1.1-2.5-2.4-3.4-3.9c-1.8-3.4-2.5-7.3-2-11.1c0.1-1,0.4-2,0.8-3c3.3-7.5,14-7.9,16.5-16.1 c1.2-3.8,0.5-7.9-1.7-11.2c-0.3-0.4-0.6-0.8-0.9-1.1c0,0-0.5-0.4-0.5-0.4C-137.4,73.3-137,75.8-137.6,77.6 M-137.4,72L-137.4,72"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129173046960860641360000008254848974134170513_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042715499702440123190000016714576248755122075_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000129173046960860641360000008254848974134170513_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127762677906135447990000008989563461557890460_",
    gradientUnits: "userSpaceOnUse",
    x1: -145.8813,
    y1: 59.3251,
    x2: -145.8813,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 7.945897e-03 184.1089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127762677906135447990000008989563461557890460_)"
    },
    points: "-160.7,72.1 -133.2,70.9  -131,118.7 -158.5,120  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052069812454282595090000013907593082022910865_",
    gradientUnits: "userSpaceOnUse",
    x1: -122.4325,
    y1: 59.3251,
    x2: -122.4325,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 1.037598e-02 184.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052069812454282595090000013907593082022910865_)"
    },
    d: "M-116.7,102c-2.7,3.8-4.5,5.3-11,6.8 c-2.4,0.5-5.6,1.8-5.8,5.9c-0.2,3,2.1,5.6,5.1,5.8c0.1,0,0.2,0,0.3,0c0.3,0,2.5,0,7.9-3.4c7.6-4.8,13-19.1,4.6-31.1 C-112.9,91.1-113.9,98-116.7,102"
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000016077774137606695010000009264262563553842345_",
    d: "M-116.7,102c-2.7,3.8-4.5,5.3-11,6.8 c-2.4,0.5-5.6,1.8-5.8,5.9c-0.2,3,2.1,5.6,5.1,5.8c0.1,0,0.2,0,0.3,0c0.3,0,2.5,0,7.9-3.4c7.6-4.8,13-19.1,4.6-31.1 C-112.9,91.1-113.9,98-116.7,102"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091010886363446152480000007265553352118329016_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016077774137606695010000009264262563553842345_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091010886363446152480000007265553352118329016_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134245346928874038110000005476324712747449259_",
    gradientUnits: "userSpaceOnUse",
    x1: -120.4399,
    y1: 59.3251,
    x2: -120.4399,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 9.041979e-04 184.1141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134245346928874038110000005476324712747449259_)"
    },
    points: "-150.8,105.8 -122.3,72.9  -90.1,100.8 -118.5,133.7  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020385381143680878210000003592671633275071126_",
    gradientUnits: "userSpaceOnUse",
    x1: -132.8758,
    y1: 59.3251,
    x2: -132.8758,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 1.037598e-02 184.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020385381143680878210000003592671633275071126_)"
    },
    d: "M-132.7,95.1c-21.9,1.8-15,18.6-14.6,19.5 c0.2,0.5,3.9,10.5,19.2,6.8c-12.9,2-15.8-9.5-12.9-13.8c2.3-3.4,5.2-5,14-7.4c9.8-2.6,10.2-12.4,9.8-14.8c-0.5-3-3.6-10.2-8.5-13.4 C-125.7,72-107.6,93-132.7,95.1"
  }), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000012433102587468206680000011949314829539157894_",
    d: "M-132.7,95.1c-21.9,1.8-15,18.6-14.6,19.5 c0.2,0.5,3.9,10.5,19.2,6.8c-12.9,2-15.8-9.5-12.9-13.8c2.3-3.4,5.2-5,14-7.4c9.8-2.6,10.2-12.4,9.8-14.8 c-0.5-3-3.6-10.2-8.5-13.4C-125.7,72-107.6,93-132.7,95.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176746642871880697670000008374900714325723805_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012433102587468206680000011949314829539157894_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176746642871880697670000008374900714325723805_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065040905581996480860000002326081327429190790_",
    gradientUnits: "userSpaceOnUse",
    x1: -131.0497,
    y1: 59.3251,
    x2: -131.0497,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 -7.146347e-03 184.0977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065040905581996480860000002326081327429190790_)"
    },
    points: "-175.4,82.1 -116.5,53.5  -86.7,114.9 -145.6,143.5  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066497349085885756220000016839855158172000679_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.6475,
    y1: 59.3251,
    x2: -143.6475,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 1.037598e-02 184.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066497349085885756220000016839855158172000679_)"
    },
    d: "M-149.2,96.1c-10.7,11.2,1.5,21.9,0.7,20.6 c-2.8-4.3-7.8-16.1,5.7-23.1c16-8.4,6.7-21,5.5-21.6C-128.5,88-144.1,90.7-149.2,96.1"
  }), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000180344807565141997770000003497822675886298499_",
    d: "M-149.2,96.1c-10.7,11.2,1.5,21.9,0.7,20.6 c-2.8-4.3-7.8-16.1,5.7-23.1c16-8.4,6.7-21,5.5-21.6C-128.5,88-144.1,90.7-149.2,96.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026868772937663436340000004839150717168360369_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180344807565141997770000003497822675886298499_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026868772937663436340000004839150717168360369_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035497924199585333550000007102761588704492680_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.4314,
    y1: 59.3251,
    x2: -143.4314,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 1.037598e-02 184.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -160,
    y: 72,
    style: {
      fill: "url(#SVGID_00000035497924199585333550000007102761588704492680_)"
    },
    width: 33.1,
    height: 45.9
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109722778689153705200000005004905596718515093_",
    gradientUnits: "userSpaceOnUse",
    x1: -118.0223,
    y1: 59.3251,
    x2: -118.0223,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 1.037598e-02 184.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109722778689153705200000005004905596718515093_)"
    },
    d: "M-115.5,99.9c-3,6.3-7.6,7.6-7.6,7.6 c1.4-0.2,2.8-0.7,4.1-1.4c0.9-0.5,4.9-3.8,5.8-8c0.5-2.1,0.5-4.3,0.1-6.5c-0.3-1.4-0.8-2.8-1.5-4.1c-0.3-0.5-0.7-0.9-1-1.4 C-112,93-115.6,99.9-115.5,99.9"
  }), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000120550579493154616630000015028776809008008832_",
    d: "M-115.5,99.9c-3,6.3-7.6,7.6-7.6,7.6 c1.4-0.2,2.8-0.7,4.1-1.4c0.9-0.5,4.9-3.8,5.8-8c0.5-2.1,0.5-4.3,0.1-6.5c-0.3-1.4-0.8-2.8-1.5-4.1c-0.3-0.5-0.7-0.9-1-1.4 C-112,93-115.6,99.9-115.5,99.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119091777115031974390000002290328707706500257_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120550579493154616630000015028776809008008832_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119091777115031974390000002290328707706500257_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035531186022114718950000007002601688569127305_",
    gradientUnits: "userSpaceOnUse",
    x1: -117.6077,
    y1: 59.3251,
    x2: -117.6077,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 -1.009811e-03 184.1129)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000035531186022114718950000007002601688569127305_)"
    },
    points: "-133.8,98.3 -118.4,80.6  -101.4,95.3 -116.8,113  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119836307258693743990000012606374115617224586_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.7872,
    y1: 59.3251,
    x2: -143.7872,
    y2: 122.3251,
    gradientTransform: "matrix(1 0 0 -1 1.037598e-02 184.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119836307258693743990000012606374115617224586_)"
    },
    d: "M-143.2,84.3c-9.7,3.4-4-3.6-4-3.6 s-8.5,7.8,1.7,5.4c11.1-2.5,8.1-14,8.1-14C-136.9,81.9-143.2,84.3-143.2,84.3"
  }), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000179608637502037585040000002298058688331054523_",
    d: "M-143.2,84.3c-9.7,3.4-4-3.6-4-3.6s-8.5,7.8,1.7,5.4 c11.1-2.5,8.1-14,8.1-14C-136.9,81.9-143.2,84.3-143.2,84.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183966529533645540440000008041903325206262674_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179608637502037585040000002298058688331054523_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183966529533645540440000008041903325206262674_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111879065418585596820000013354169802984128129_",
    gradientUnits: "userSpaceOnUse",
    x1: -144.4374,
    y1: 61.9622,
    x2: -144.4374,
    y2: 124.9622,
    gradientTransform: "matrix(1.0012 -4.236045e-03 -4.236045e-03 -1.0012 2.3005 183.8961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C761"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#A97F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#261212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6F4E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#1F1410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F2E2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AD5D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111879065418585596820000013354169802984128129_)"
    },
    points: "-154.2,69.7 -132.2,68.6  -131.3,86 -153.4,87.1  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080187660281075689000000009706485434872944011_",
    cx: -4.1039,
    cy: 17.8954,
    r: 20.3715,
    gradientTransform: "matrix(0.839 0.5442 -0.5442 0.839 47.5213 23.743)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF4E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04596311,
    style: {
      stopColor: "#FDE9C7",
      stopOpacity: 0.954
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    style: {
      stopColor: "#FADBA4",
      stopOpacity: 0.8832
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#F8CF87",
      stopOpacity: 0.806
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2767,
    style: {
      stopColor: "#F6C66F",
      stopOpacity: 0.7233
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3667,
    style: {
      stopColor: "#F5BE59",
      stopOpacity: 0.6333
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4668,
    style: {
      stopColor: "#F4B847",
      stopOpacity: 0.5332
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5827,
    style: {
      stopColor: "#F3B43A",
      stopOpacity: 0.4173
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7284,
    style: {
      stopColor: "#F2B232",
      stopOpacity: 0.2716
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2B130",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000080187660281075689000000009706485434872944011_)"
    },
    cx: 34.3,
    cy: 36.5,
    r: 20.4
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000183240366589956784140000001305837959037716900_",
    cx: -2516.4036,
    cy: 93.4488,
    r: 40.4101,
    gradientTransform: "matrix(0.1427 9.255276e-02 -0.1646 0.2539 516.5399 360.1676)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF4E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04596311,
    style: {
      stopColor: "#FDE9C7",
      stopOpacity: 0.954
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    style: {
      stopColor: "#FADBA4",
      stopOpacity: 0.8832
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#F8CF87",
      stopOpacity: 0.806
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2767,
    style: {
      stopColor: "#F6C66F",
      stopOpacity: 0.7233
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3667,
    style: {
      stopColor: "#F5BE59",
      stopOpacity: 0.6333
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4668,
    style: {
      stopColor: "#F4B847",
      stopOpacity: 0.5332
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5827,
    style: {
      stopColor: "#F3B43A",
      stopOpacity: 0.4173
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7284,
    style: {
      stopColor: "#F2B232",
      stopOpacity: 0.2716
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2B130",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183240366589956784140000001305837959037716900_)"
    },
    d: "M147.8,154.7c-3.7,5.7-9.2,8.6-12.4,6.5 c-3.2-2.1-2.8-8.3,0.9-14c3.7-5.7,9.2-8.6,12.4-6.5C151.9,142.8,151.5,149.1,147.8,154.7z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForexPro);
export default __webpack_public_path__ + "static/media/Forex_pro.c376f0032f0a4627ca927e941f17d73f.svg";
export { ForwardRef as ReactComponent };